import { render, staticRenderFns } from "./CamerasReview.vue?vue&type=template&id=bf3d9024&scoped=true"
import script from "./CamerasReview.vue?vue&type=script&lang=js"
export * from "./CamerasReview.vue?vue&type=script&lang=js"
import style0 from "./CamerasReview.vue?vue&type=style&index=0&id=bf3d9024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3d9024",
  null
  
)

export default component.exports